import axios from 'axios'
import { store } from '../../store'
import qs from 'qs'
import config from "@/../config";

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

axios.interceptors.request.use(
  config => {
    const c = {...config}
    // if (config.url) {
    //   c.headers["Authorization"] = window.localStorage.getItem("token") || "";
    // }
    return c;
  },
  err => {
    return Promise.reject(err);
  }
);

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
          params: params
        })
        .then(response => {
          if(response.data.code === -1001){ // 此判断只针对樱花校园盒子
            window.localStorage.removeItem('sakuraToken')
            getSakuraToken('get', url, params).then(response =>{
              resolve(response)
            })
          }else{
            resolve(response.data);
          } // 登录失效后重新登录成功后再次发起请求
        })
        .catch(err => {
          reject(err)
        })
    })
}
  
  
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  
  export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, data,[{'Accept':'application/json, text/javascript'}])
        .then(response => {
          if(response.data.code === -1001){ // 此判断只针对樱花校园盒子
            window.localStorage.removeItem('sakuraToken')
            getSakuraToken('post', url, data).then(res =>{
              resolve(res)
            })
          }else{
            resolve(response.data);
          } // 登录失效后重新登录成功后再次发起请求
        }, err => {
          reject(err)
        })
    })
  }

  function getSakuraToken(methods,url,data){
    return new Promise((resolve, reject) => {
      axios.post(config.SAKURA_BASE_URL + '/api/sakura/syncUser', qs.stringify({
        uid: store.getters.uuid,
        nickname: store.getters.userName,
        avatar: store.getters.userIcon,
        token: store.getters.userToken
      })).then((res) => {
        if(res.data.return_code == 200 || res.data.code == 200){
          window.localStorage.setItem('sakuraToken', res.data.data._token)
          if(methods === 'get'){ // 获取完最新的token后重新发起请求
            data._token = res.data.data._token
            get(url,data).then(res =>{
              resolve(res)
            })
          }else{
            data.set('_token', res.data.data._token)
            post(url,data).then(res =>{
              resolve(res)
            })
          }
        }
      })
    })
  }


  export function postParams(url, params) {
    return new Promise((resolve, reject) => {
      axios.post(url, params, [{'Accept':'application/json, text/javascript'}])
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  }

  